import { Component, Input } from "@angular/core";

@Component({
    selector: "app-mids-table-cell-content",
    templateUrl: "./mids-table-cell-content.component.html",
    styleUrls: ["./mids-table-cell-content.component.less"],
    standalone: false
})
export class MidsTableCellContentComponent {

    @Input() columnId: string;
    @Input() element: any;
    @Input() showingDeletedMids: boolean;

    get sortingKeyForDateDeleted(): number {
        // Timezone independent (as just for comparision with like values)
        return new Date(this.element.deletedUtc).getTime();
    }

}
